import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import SectionWrapper from "../../components/SectionWrapper/SectionWrapper";

/**
 * ⚙️ Página de Preferencias del Usuario
 *
 * Aquí el usuario podrá configurar sus preferencias
 * personales dentro del sistema.
 */
const UserPreferencesPage = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <SectionWrapper>
        <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-4">
          Preferencias del Usuario
        </h2>

        <p className="text-gray-600 dark:text-gray-400">
          Aquí podrás configurar tus preferencias personales dentro del sistema,
          como idioma, formato de fecha, notificaciones y otras opciones
          relacionadas con tu cuenta.
        </p>
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default UserPreferencesPage;